import { FeaturePermission } from "./FeaturePermission";

export interface GlobalStore {
  userFeaturePermissions: FeaturePermission[];
  
  incomingInvoiceFilter: {
    None: null;
    General: string;
    ProdPurchase: string;
    DiffTax: string;
  };
  fileType: {
    pdf: string;
    doc: string;
    docx: string;
    xls: string;
    xlsx: string;
    csv: string;
    xml: string;
  };
  itemState: {
    InEdit: string;
    SelectToRemove: string;
    ShowDetails: string;
    Selected: string;
  };
  flags: {
    IsCarSale: Flag;
    IsPostCalc: Flag;
    IsNewPostCalcType: Flag;
    IsShcPostCalcType: Flag;
    IsStockPostCalcType: Flag;
    IsCarRectItem: Flag;
  };
  tableName: {
    PayMode: string;
    Tax: string;
  };
}

const globalStore: GlobalStore = {
  userFeaturePermissions: [],
  incomingInvoiceFilter: {
    None: null,
    General: "general",
    ProdPurchase: "prod-purchase",
    DiffTax: "diff-tax"
  },
  fileType: {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    csv: "text/csv",
    xml: "application/xml",
  },
  itemState: {
    InEdit: "InEdit",
    SelectToRemove: "SelectToRemove",
    ShowDetails: "ShowDetails",
    Selected: "Selected",
  },
  flags: {
    IsCarSale: { flag: "GJÉ", tooltip: "Gépjármű értékesítéshez tartozik" },
    IsPostCalc: { flag: "UTÓK", tooltip: "Utókalkulációban szerepel" },
    IsNewPostCalcType: { flag: "UGJ", tooltip: "Új gépjárműves utókalkulációhoz tartozik" },
    IsShcPostCalcType: { flag: "HGJ", tooltip: "Használt gépjárműves utókalkulációhoz tartozik" },
    IsStockPostCalcType: { flag: "ELÁBÉ", tooltip: "Készletértéket módosít (ELÁBÉ -ban szerepel)" },
    IsCarRectItem: { flag: "GJ HELYESB", tooltip: "Gépjármű helyesbítő típusú" },
  },  
  tableName: {
    PayMode: "csgenpaymode",
    Tax: "csgentax",
  },

}

export interface Flag {
  flag: string;
  tooltip: string;
}

export default globalStore;